/**
 * Status values used across async job polling, SSE streaming, and UI toasts.
 */

/** Backend async job statuses (Redis progress tracking) */
export const JOB_STATUS = {
  PROCESSING: "processing",
  COMPLETED: "completed",
  FAILED: "failed",
} as const;

/** UI toast/notification severity levels */
export const TOAST_SEVERITY = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
} as const;

/** Dashboard type identifiers used in filter routing and storage */
export const DASHBOARD_TYPES = {
  SALES: "Sales",
  INVENTORY: "Inventory",
  ADVERTISING: "Advertising",
  MARKETING: "Marketing",
  RAW_DATA: "Raw Data",
} as const;

/** Dashboard generation name values stored in STORAGE_KEYS.DASHBOARD_GENERATING_NAME */
export const DASHBOARD_NAMES = {
  SALES: "Sales",
  MARKET_WATCH_DATA: "Market Watch Data",
  MARKET_WATCH_RAW_DATA: "Market Watch Raw Data",
  ADVERTISING_DATA: "Advertising Data",
  ADVERTISING: "Advertising",
  INVENTORY: "Inventory",
} as const;

/** Price cluster mode values */
export const PRICE_CLUSTER_MODES = {
  GLOBAL: "global" as const,
  DYNAMIC: "dynamic" as const,
};
